import * as React from 'react';
import { ClearAllProps } from '../../components/filters/clear-all';
//import { removeLoader } from '../../helpers/scroll-to-month';

const ClearAllView: React.StatelessComponent<ClearAllProps> = props => {
    function onClick(evt: React.MouseEvent<HTMLButtonElement>) {
        props.removeAllFilters();
        window.location.hash = "";
        //setTimeout(() => removeLoader(), 500)
    }

    return (
        <button type="button" className="un-button hyperlink bold" onClick={onClick}>{props.text.clearAllFiltersButtonText}</button>
    );
}

export default ClearAllView;